// TODO: CONSISTENCE THEME NAMES: e.g. blue -> tuxis_blue(light, main, dark)
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import i18n from "i18next";
import { useSession } from "next-auth/react";
import dynamic from "next/dynamic";
import Head from "next/head";
import { useEffect, useLayoutEffect, useState } from "react";
import { connect } from "react-redux";
import { set_theme } from "../../redux/shared/shared.methods";
import { filter_cookies_get, filter_type } from "./cookie-jar";
import { TuxisTheme } from "./theme";

export const Page = (props) => {
	// PROPS
	const [darkMode, setDarkMode] = useState(props.theme === "(prefers-color-scheme: dark)");

	const { data: session } = useSession();

	const userDetails = session?.portal.user_details;

	useEffect(() => {
		i18n.changeLanguage(userDetails?.language);
	}, [userDetails]);

	/* ---------------------------- MATERIAL UI THEME --------------------------- */
	return (
		<>
			{/* HEADER  */}
			<Head>
				<title>{`${props.title} | ${process.env.NEXT_PUBLIC_APP_NAME}`}</title>
			</Head>

			{/* BODY  */}
			<LayoutWrapper set_dark_mode={setDarkMode} {...props}>
				<ThemeProvider theme={TuxisTheme(darkMode)}>
					<CssBaseline />
					<Container maxWidth="none" disableGutters sx={{ pt: 4 }}>
						{props.children}
					</Container>
				</ThemeProvider>
			</LayoutWrapper>
		</>
	);
};
const LayoutWrapperClient = (props) => {
	const systemDarkTheme = useMediaQuery("(prefers-color-scheme: dark)");

	useLayoutEffect(() => {
		if (props.theme) {
			props.set_dark_mode(props.theme === "(prefers-color-scheme: dark)");
			return;
		}

		const localSavedTheme = filter_cookies_get(filter_type.THEME);
		if (localSavedTheme) {
			props.set_theme(localSavedTheme);
			return;
		}

		const timer = setTimeout(() => {
			props.set_theme(
				systemDarkTheme ? "(prefers-color-scheme: dark)" : "(prefers-color-scheme: light)",
			);
		}, 0);

		return () => clearTimeout(timer);
	}, [props, systemDarkTheme]);

	return props.children;
};

const LayoutWrapper = dynamic(() => Promise.resolve(LayoutWrapperClient), {
	ssr: false,
});

const mapStateToProps = (state) => ({
	theme: state.shared_state.theme,
});

const mapDispatchToProps = (dispatch) => ({
	set_theme: (theme) => dispatch(set_theme(theme)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page);
